import React, { useState } from 'react';
import { connectRefinementList, Highlight } from 'react-instantsearch-dom';
import styled from 'styled-components';
import { Checkbox } from '../../../../../styles/theme/default/default';
import { numberFormat } from '../../../../../utils/helper';

const colorCodes = {
  Blue: '#4372A4',
  Grey: '#A0B0B4',
  Neutral: '#DFD2C3',
  Black: '#221F20',
  Pink: '#E6B2B4',
  Yellow: '#E5BC59',
  Green: '#3F5349',
  Red: '#AA2025',
  Navy: '#123764',
  Orange: '#BF6929',
  White: '#f8f8f8',
  Purple: '#57317A',
  Teal: '#53A6A9',
  Brown: '#7A5131'
};

export const ColorDot = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 8px;
  background-color: ${props => props.color};
`;

const setColorDot = color => {
  if (color === 'Multi') {
    return (
      <img
        style={{ marginLeft: '7px' }}
        width="22px"
        src="https://theinside.imgix.net/common/colors-wheel.svg"
      />
    );
  } else {
    return <ColorDot color={colorCodes[color]} />;
  }
};

const RefinementList = props => {
  const {
    items,
    isFromSearch,
    refine,
    searchForItems,
    createURL,
    searchable,
    attribute
  } = props;

  const [searchSting, setSearchString] = useState('');
  return (
    <>
      <div className="ais-RefinementList-searchBox">
        {searchable && (
          <div className="ais-SearchBox">
            <form
              noValidate=""
              className="ais-SearchBox-form"
              action=""
              role="search"
            >
              <input
                type="search"
                placeholder="Search here…"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                required=""
                maxLength="512"
                className="ais-SearchBox-input"
                value={searchSting}
                onChange={event => {
                  setSearchString(event.currentTarget.value);
                  searchForItems(event.currentTarget.value);
                }}
              />

              <button
                type="submit"
                title="Submit your search query."
                className="ais-SearchBox-submit"
              >
                <svg
                  className="ais-SearchBox-submitIcon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 40 40"
                >
                  <path d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z" />
                </svg>
              </button>
              {searchSting && (
                <button
                  type="reset"
                  title="Clear the search query."
                  className="ais-SearchBox-reset"
                  hidden=""
                  onClick={() => {
                    searchForItems('');
                    setSearchString('');
                  }}
                >
                  <svg
                    className="ais-SearchBox-resetIcon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    width="10"
                    height="10"
                  >
                    <path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z" />
                  </svg>
                </button>
              )}
            </form>
          </div>
        )}
      </div>
      <ul className="ais-RefinementList-list">
        {items.map(item => (
          <li
            className="ais-RefinementList-item"
            key={item.label}
            onClick={event => {
              refine(item.value);
              setSearchString('');
              searchForItems('');
            }}
          >
            <label className="ais-RefinementList-label d-flex align-items-center mt-3">
              <Checkbox className="custom-checkbox" checked={item.isRefined} />
              {attribute == 'colors' && setColorDot(item.label)}
              <span className="ais-RefinementList-labelText">
                {isFromSearch ? (
                  <Highlight attribute="label" hit={item} />
                ) : (
                  item.label
                )}
              </span>
              <span className="ais-RefinementList-count">
                ({numberFormat(item.count, 0, '.', ',')})
              </span>
            </label>
          </li>
        ))}
      </ul>
    </>
  );
};

const CustomRefinementList = connectRefinementList(RefinementList);

export default CustomRefinementList;
